<template>
	<div>
		<v-layout class="py-2">
			<div class="listing-heading">Purchase Order</div>
			<v-spacer></v-spacer>
			<v-btn color="grey lighten-3" tile depressed class="mx-3" @click="goBack()">
				<v-icon small left>mdi-arrow-left</v-icon>
				Back
			</v-btn>
		</v-layout>
		<div>
			<ModuleSettings type="purchase-order" title="purchase order"></ModuleSettings>
		</div>
		<div class="mt-5">
			<TermsAndConditions module="purchase-order"></TermsAndConditions>
		</div>
	</div>
</template>
<script>
import ModuleSettings from "@/view/components/ModuleSettings";
import TermsAndConditions from "@/view/module/setting/pages/TermsAndConditions";
export default {
	name: "PurchaseOrder",
	data() {
		return {
			remark: null,
			pageLoading: null,
		};
	},
	components: {
		ModuleSettings,
		TermsAndConditions,
	},
};
</script>
